<template>
  <div v-if="visible" class="overlay-modal">
    <div class="modal-crear">
      <h4 class="modal-titulo">Crear formulario</h4>
      <p class="nota">
        El formulario se crea suelto, con sus preguntas. Después se vincula
        desde los indicadores de opinión; cómo se reparte y cómo se califica
        depende del tipo y de la modalidad que elijas aquí.
      </p>

      <div class="form-group">
        <label for="nombre-form">Nombre del formulario</label>
        <input id="nombre-form" v-model="nombre" type="text" placeholder="Encuesta de satisfacción 2026" />
      </div>

      <div class="form-group">
        <label for="tipo-form">Tipo de instrumento</label>
        <select id="tipo-form" v-model="herramienta">
          <option v-for="h in herramientasOpinion" :key="h.valor" :value="h.valor">
            {{ h.etiqueta }}
          </option>
        </select>
        <small v-if="tiposPreguntaPermitidos.length" class="ayuda">
          Una {{ etiquetaHerramienta.toLowerCase() }} se lee por porcentaje de cumplimiento por
          opción, así que solo admite preguntas de opción única.
        </small>
      </div>

      <div class="form-group">
        <label for="modalidad-form">¿Cómo califica?</label>
        <select id="modalidad-form" v-model="modalidad">
          <option value="por_pregunta">Cada pregunta califica un indicador</option>
          <option value="formulario_completo">El formulario completo califica un indicador</option>
        </select>
        <small class="ayuda">
          <template v-if="modalidad === 'por_pregunta'">
            El formulario es compartido: al vincularlo se eligen qué preguntas le corresponden a
            cada indicador, y su nota es el promedio de esas preguntas.
          </template>
          <template v-else>
            El formulario entero evalúa un solo indicador: al vincularlo va completo, se califica
            con una sola nota y sus resultados se leen respuesta por respuesta.
          </template>
        </small>
      </div>

      <div class="form-group">
        <label>Grupos de interés *</label>
        <div class="grupos-lista">
          <label v-for="g in grupos" :key="g.id_grupo_interes" class="grupo-check">
            <input type="checkbox" :value="g.id_grupo_interes" v-model="gruposSeleccionados" />
            {{ g.nombre }}
          </label>
          <p v-if="!grupos.length" class="info">Cargando grupos…</p>
        </div>
      </div>

      <!-- Banco de preguntas: filtrado por el grupo activo en el panel -->
      <div v-if="gruposSeleccionados.length" class="banco">
        <div class="seccion-head">
          <h5>Banco de preguntas</h5>
          <div class="banco-filtro">
            <select v-model="grupoBancoActivo" class="banco-grupo-select">
              <option :value="null">— Elegir grupo —</option>
              <option v-for="id in gruposSeleccionados" :key="id" :value="id">
                {{ nombreGrupo(id) }}
              </option>
            </select>
            <span v-if="grupoBancoActivo && bancoCompatible.length" class="contador">{{ bancoCompatible.length }}</span>
          </div>
        </div>

        <p v-if="!grupoBancoActivo" class="info">Selecciona un grupo para ver su banco.</p>
        <p v-else-if="cargandoBanco" class="info">Cargando banco…</p>
        <p v-else-if="!bancoCompatible.length" class="info">
          <template v-if="banco.length">
            Las preguntas del banco de este grupo no son de opción única, así que no caben en
            una {{ etiquetaHerramienta.toLowerCase() }}.
          </template>
          <template v-else>
            No hay preguntas en el banco para este grupo.
          </template>
        </p>

        <template v-else>
          <label class="banco-select-todo">
            <input type="checkbox" :checked="todosBancoSeleccionados" @change="toggleTodosBanco" />
            Seleccionar todo ({{ bancoCompatible.length }})
          </label>
          <ul class="lista-banco">
            <li v-for="b in bancoCompatible" :key="b.id_pregunta" class="item-banco">
              <label>
                <input type="checkbox" :value="b.id_pregunta" v-model="bancoSeleccionado" />
                <span class="bq-texto">{{ b.enunciado || b.pregunta }}</span>
              </label>
            </li>
          </ul>
          <button
            type="button"
            class="btn btn-sm guardar"
            :disabled="!bancoSeleccionado.length"
            @click="importarDelBanco"
          >
            Agregar {{ bancoSeleccionado.length || '' }} del banco
          </button>
        </template>
      </div>

      <div class="seccion">
        <div class="seccion-head">
          <h5>Preguntas</h5>
          <button type="button" class="btn btn-sm guardar" :disabled="mostrandoBorrador" @click="abrirBorrador">+ Pregunta</button>
        </div>

        <!-- Borrador de nueva pregunta -->
        <div v-if="mostrandoBorrador" class="borrador-card">
          <div class="pregunta-head">
            <strong>Nueva pregunta</strong>
            <button type="button" class="btn-quitar" @click="cerrarBorrador">✕</button>
          </div>
          <div class="form-group">
            <label>Enunciado</label>
            <input v-model="borrador.enunciado" type="text" placeholder="¿En cuánto calificaría…?" />
          </div>
          <div class="form-group">
            <label>Tipo de respuesta</label>
            <select v-model="borrador.tipo_respuesta">
              <option value="" disabled>— Seleccionar tipo —</option>
              <option v-for="t in tiposDisponibles" :key="t.valor" :value="t.valor">{{ t.etiqueta }}</option>
            </select>
          </div>
          <div v-if="requiereOpciones(borrador.tipo_respuesta)" class="form-group">
            <label>Opciones (una por línea, mínimo 2)</label>
            <textarea v-model="borrador.opcionesTexto" rows="3" placeholder="Totalmente de acuerdo&#10;De acuerdo&#10;En desacuerdo"></textarea>
          </div>
          <div v-if="gruposSeleccionados.length > 1" class="form-group">
            <label>Destinatarios de esta pregunta</label>
            <div class="radio-dest">
              <label class="radio-label"><input type="radio" :value="true" v-model="borrador.general" /> Todos los grupos</label>
              <label class="radio-label"><input type="radio" :value="false" v-model="borrador.general" /> Solo estos:</label>
            </div>
            <div v-if="!borrador.general" class="grupos-check-mini">
              <label v-for="id in gruposSeleccionados" :key="id" class="grupo-check-mini">
                <input type="checkbox" :value="id" v-model="borrador.gruposDestino" />
                {{ nombreGrupo(id) }}
              </label>
            </div>
          </div>
          <div class="borrador-botones">
            <button type="button" class="btn btn-sm guardar" :disabled="!borrador.enunciado.trim() || !borrador.tipo_respuesta" @click="confirmarBorrador">Agregar</button>
          </div>
        </div>

        <p v-if="!preguntas.length && !mostrandoBorrador" class="info">Agrega al menos una pregunta.</p>

        <div v-for="(p, i) in preguntas" :key="i" class="pregunta-card">
          <div class="pregunta-head">
            <strong>Pregunta {{ i + 1 }}</strong>
            <button type="button" class="btn-quitar" @click="preguntas.splice(i, 1)">✕</button>
          </div>
          <div class="form-group">
            <label>Enunciado</label>
            <input v-model="p.enunciado" type="text" placeholder="¿En cuánto calificaría…?" />
          </div>
          <div class="form-group">
            <label>Tipo de respuesta</label>
            <!-- La herramienta manda: una encuesta solo admite opción única. -->
            <select v-model="p.tipo_respuesta" :disabled="tiposDisponibles.length === 1" @change="alCambiarTipoPregunta(p)">
              <option v-for="t in tiposDisponibles" :key="t.valor" :value="t.valor">
                {{ t.etiqueta }}
              </option>
            </select>
          </div>
          <div v-if="requiereOpciones(p.tipo_respuesta)" class="form-group">
            <label>Opciones (una por línea, mínimo 2)</label>
            <textarea v-model="p.opcionesTexto" rows="3" placeholder="Totalmente de acuerdo&#10;De acuerdo&#10;En desacuerdo"></textarea>
          </div>
          <div v-if="gruposSeleccionados.length > 1" class="form-group">
            <label>Destinatarios</label>
            <div class="radio-dest">
              <label class="radio-label"><input type="radio" :value="true" v-model="p.general" /> Todos los grupos</label>
              <label class="radio-label"><input type="radio" :value="false" v-model="p.general" /> Solo estos:</label>
            </div>
            <div v-if="!p.general" class="grupos-check-mini">
              <label v-for="id in gruposSeleccionados" :key="id" class="grupo-check-mini">
                <input type="checkbox" :value="id" v-model="p.gruposDestino" />
                {{ nombreGrupo(id) }}
              </label>
            </div>
          </div>
        </div>
      </div>

      <div v-if="gruposSeleccionados.length && preguntas.length" class="resumen-grupos">
        <p class="resumen-titulo">Distribución de preguntas por grupo</p>
        <ul class="resumen-lista">
          <li
            v-for="id in gruposSeleccionados"
            :key="id"
            :class="['resumen-item', { 'resumen-item--vacio': contarPreguntasPorGrupo(id) === 0 }]"
          >
            {{ nombreGrupo(id) }}: {{ contarPreguntasPorGrupo(id) }} pregunta(s)
            <span v-if="contarPreguntasPorGrupo(id) === 0" class="resumen-alerta">sin preguntas — no se puede guardar</span>
          </li>
        </ul>
      </div>

      <MensajeFlotante
        :visible="mensajeVisible"
        :mensaje="mensajeTexto"
        :tipo="mensajeTipo"
        @cerrar="mensajeVisible = false"
      />

      <div class="botones">
        <button class="btn salir" :disabled="guardando" @click="$emit('cerrar')">Cancelar</button>
        <button class="btn guardar" :disabled="guardando || !puedeGuardar" @click="guardar">
          {{ guardando ? 'Creando…' : 'Crear formulario' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
/**
 * Creación del formulario de opinión.
 *
 * Al publicar se congela `preguntas_snapshot`: editar una pregunta después no
 * altera el formulario ya publicado.
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

import { ref, reactive, computed, watch } from 'vue'
import MensajeFlotante from '@/components/MensajeFlotante.vue'
import { useGestionInstrumento } from '@/store/GestionInstrumentos'
import { useGestionGrupoInteres } from '@/store/GestionGrupoInteres'
import { useGestionPreguntas } from '@/store/GestionPreguntas'
import { useGestionTipoComponente } from '@/store/GestionTipoComponente'
import { getCatalogoInstrumentosService } from '@/services/InstrumentosService'
import type { CatalogoInstrumento, ModalidadInstrumento } from '@/interfaces/Instrumetos'

interface PreguntaNueva {
  enunciado: string
  tipo_respuesta: string
  opcionesTexto: string
  id_pregunta_origen?: number | null
  general: boolean
  gruposDestino: number[]
}

const props = defineProps<{ visible: boolean }>()

const emit = defineEmits<{
  (e: 'cerrar'): void
  (e: 'creado', mensaje: string): void
}>()

const instrumentoStore = useGestionInstrumento()
const grupoStore = useGestionGrupoInteres()
const preguntaStore = useGestionPreguntas()
const tipoStore = useGestionTipoComponente()

const TIPOS_CON_OPCIONES = ['opcion_unica', 'single_choice', 'multiple_choice', 'casillas']

const OPCIONES_UNICA_DEFAULT = 'Plena o Completa\nAlta (o)\nAceptable\nBajo (a)\nNingún (a)'

/** Catálogo de tipos de pregunta que ofrece el modal. */
const TIPOS_PREGUNTA = [
  { valor: 'opcion_unica', etiqueta: 'Opción única' },
  { valor: 'escala_likert', etiqueta: 'Escala Likert' },
  { valor: 'escala_lineal', etiqueta: 'Escala lineal' },
  { valor: 'multiple_choice', etiqueta: 'Casillas' },
  { valor: 'short_text', etiqueta: 'Respuesta corta' },
  { valor: 'long_text', etiqueta: 'Párrafo' }
]

const nombre = ref('')
const herramienta = ref('encuesta')
const modalidad = ref<ModalidadInstrumento>('por_pregunta')
const catalogo = ref<CatalogoInstrumento>({ herramientas: [], modalidades: [] })
const gruposSeleccionados = ref<number[]>([])
const grupoBancoActivo = ref<number | null>(null)
const preguntas = ref<PreguntaNueva[]>([])
const guardando = ref(false)
const mensajeVisible = ref(false)
const mensajeTexto = ref('')
const mensajeTipo = ref<'positivo' | 'error'>('error')

function mostrarMensaje(texto: string, tipo: 'positivo' | 'error' = 'error') {
  mensajeTexto.value = texto
  mensajeTipo.value = tipo
  mensajeVisible.value = true
}

const mostrandoBorrador = ref(false)
const borrador = reactive<PreguntaNueva>({ enunciado: '', tipo_respuesta: '', opcionesTexto: '', general: true, gruposDestino: [] })

// Banco de preguntas del grupo activo en el panel de banco
const banco = ref<any[]>([])
const bancoSeleccionado = ref<number[]>([])
const cargandoBanco = ref(false)

const grupos = computed(() => grupoStore.grupos ?? [])

/** Solo herramientas de opinión: esto arma formularios, no fichas documentales. */
const herramientasOpinion = computed(() =>
  catalogo.value.herramientas.filter(h => h.tipo_informacion === 'opinion')
)

const herramientaActual = computed(() =>
  herramientasOpinion.value.find(h => h.valor === herramienta.value)
)

const etiquetaHerramienta = computed(() => herramientaActual.value?.etiqueta ?? 'encuesta')

/** Vacío = la herramienta admite cualquier tipo de pregunta. */
const tiposPreguntaPermitidos = computed(() => herramientaActual.value?.tipos_pregunta ?? [])

const tiposDisponibles = computed(() => {
  const permitidos = tiposPreguntaPermitidos.value
  if (!permitidos.length) return TIPOS_PREGUNTA
  return TIPOS_PREGUNTA.filter(t => permitidos.includes(t.valor))
})

/** Del banco solo entran las preguntas que la herramienta admite. */
const bancoCompatible = computed(() => {
  const permitidos = tiposPreguntaPermitidos.value
  if (!permitidos.length) return banco.value
  return banco.value.filter(b => permitidos.includes(b.tipo_respuesta || b.tipo || ''))
})

const todosBancoSeleccionados = computed(() =>
  bancoCompatible.value.length > 0 &&
  bancoCompatible.value.every(b => bancoSeleccionado.value.includes(b.id_pregunta))
)

function toggleTodosBanco() {
  if (todosBancoSeleccionados.value) {
    bancoSeleccionado.value = []
  } else {
    bancoSeleccionado.value = bancoCompatible.value.map(b => b.id_pregunta)
  }
}

const puedeGuardar = computed(() =>
  !!nombre.value.trim() &&
  gruposSeleccionados.value.length > 0 &&
  preguntas.value.length > 0 &&
  preguntas.value.every(p =>
    p.enunciado.trim() && p.tipo_respuesta &&
    (!requiereOpciones(p.tipo_respuesta) || opcionesDe(p).length >= 2) &&
    (p.general || p.gruposDestino.length > 0)
  ) &&
  gruposSeleccionados.value.every(id => contarPreguntasPorGrupo(id) > 0)
)

function nombreGrupo(id: number): string {
  return grupos.value.find(g => g.id_grupo_interes === id)?.nombre ?? `#${id}`
}

function contarPreguntasPorGrupo(idGrupo: number): number {
  return preguntas.value.filter(p => p.general || p.gruposDestino.includes(idGrupo)).length
}

watch(
  () => props.visible,
  async (v) => {
    if (!v) return
    nombre.value = ''
    herramienta.value = 'encuesta'
    modalidad.value = 'por_pregunta'
    gruposSeleccionados.value = []
    grupoBancoActivo.value = null
    preguntas.value = []
    mensajeVisible.value = false
    mostrandoBorrador.value = false
    const [cat] = await Promise.all([
      getCatalogoInstrumentosService(),
      grupoStore.getGrupos?.().catch(() => null),
      tipoStore.getTipos?.()
    ])
    catalogo.value = cat
  }
)

/**
 * Al cambiar de herramienta se reencauzan las preguntas ya escritas al primer
 * tipo admitido: pasar a encuesta con preguntas de párrafo daría 422 al guardar.
 */
watch(herramienta, () => {
  const permitidos = tiposPreguntaPermitidos.value
  if (!permitidos.length) return

  const porDefecto = tiposDisponibles.value[0]?.valor ?? permitidos[0]
  for (const p of preguntas.value) {
    if (!permitidos.includes(p.tipo_respuesta)) p.tipo_respuesta = porDefecto
  }
  if (mostrandoBorrador.value && !permitidos.includes(borrador.tipo_respuesta)) {
    borrador.tipo_respuesta = porDefecto
  }
  bancoSeleccionado.value = bancoSeleccionado.value.filter(id =>
    bancoCompatible.value.some(b => b.id_pregunta === id)
  )
})

watch(grupoBancoActivo, async (id) => {
  banco.value = []
  bancoSeleccionado.value = []
  if (!id) return

  cargandoBanco.value = true
  try {
    banco.value = await preguntaStore.getPreguntas({ banco: true, id_grupo_interes: id } as any) ?? []
  } finally {
    cargandoBanco.value = false
  }
})

function importarDelBanco() {
  for (const b of bancoCompatible.value) {
    if (!bancoSeleccionado.value.includes(b.id_pregunta)) continue

    const opciones = Array.isArray(b.opciones) ? b.opciones : []
    preguntas.value.push({
      enunciado: b.enunciado || b.pregunta || '',
      tipo_respuesta: b.tipo_respuesta || b.tipo || 'escala_likert',
      opcionesTexto: opciones.join('\n'),
      id_pregunta_origen: b.id_pregunta,
      general: true,
      gruposDestino: []
    })
  }
  bancoSeleccionado.value = []
}

function requiereOpciones(tipo: string): boolean {
  return TIPOS_CON_OPCIONES.includes(tipo)
}

function opcionesDe(p: PreguntaNueva): string[] {
  return p.opcionesTexto.split('\n').map(o => o.trim()).filter(Boolean)
}

watch(() => borrador.tipo_respuesta, (tipo) => {
  if (tipo === 'opcion_unica') borrador.opcionesTexto = OPCIONES_UNICA_DEFAULT
})

function alCambiarTipoPregunta(p: PreguntaNueva) {
  if (p.tipo_respuesta === 'opcion_unica') p.opcionesTexto = OPCIONES_UNICA_DEFAULT
}

function abrirBorrador() {
  borrador.enunciado = ''
  const tipo = tiposDisponibles.value.length === 1 ? tiposDisponibles.value[0].valor : ''
  borrador.tipo_respuesta = tipo
  borrador.opcionesTexto = tipo === 'opcion_unica' ? OPCIONES_UNICA_DEFAULT : ''
  borrador.general = true
  borrador.gruposDestino = []
  mostrandoBorrador.value = true
}

function confirmarBorrador() {
  preguntas.value.push({ ...borrador, gruposDestino: [...borrador.gruposDestino] })
  mostrandoBorrador.value = false
}

function cerrarBorrador() {
  mostrandoBorrador.value = false
}

/** El id del tipo "Opinión" se resuelve por nombre, no por número fijo. */
function idTipoOpinion(): number | null {
  const t = (tipoStore.tipos ?? []).find((x: any) => /opini/i.test(String(x.nombre ?? '')))
  return t?.id_tipo_componente ?? null
}

async function guardar() {
  if (!puedeGuardar.value) return

  const idTipo = idTipoOpinion()
  if (!idTipo) {
    mostrarMensaje('No se encontró el tipo de componente "Información de Opinión".')
    return
  }

  guardando.value = true
  mensajeVisible.value = false
  try {
    const instrumento = await instrumentoStore.crearInstrumento({
      id_tipo_componente: idTipo,
      tipo: herramienta.value,
      modalidad: modalidad.value,
      descripcion: nombre.value.trim()
    } as any)

    if (!instrumento?.id_instrumento) {
      mostrarMensaje('No se pudo crear el formulario.')
      return
    }

    // Sincronizar grupos ANTES de crear preguntas: el backend valida que el grupo
    // de cada pregunta esté en el pivote del instrumento (422 si no está).
    await instrumentoStore.asignarGrupos(instrumento.id_instrumento, gruposSeleccionados.value)

    let orden = 1
    for (const p of preguntas.value) {
      const datosBase = {
        enunciado: p.enunciado.trim(),
        pregunta: p.enunciado.trim(),
        tipo_respuesta: p.tipo_respuesta,
        tipo: p.tipo_respuesta,
        opciones: opcionesDe(p),
        id_indicador: null,
      }

      // Para preguntas nuevas (sin origen) guardar una copia en el banco por
      // cada grupo al que aplica, para que futuros formularios puedan reutilizarlas.
      let idPreguntaOrigen = p.id_pregunta_origen ?? null
      if (!idPreguntaOrigen) {
        const gruposParaBanco = p.general ? gruposSeleccionados.value : p.gruposDestino
        for (const idGrupo of gruposParaBanco) {
          const copia = await preguntaStore.crearPregunta({
            ...datosBase,
            id_instrumento: null as any,
            id_grupo_interes: idGrupo,
            id_pregunta_origen: null,
            orden: 0,
          })
          if (copia?.id_pregunta && !idPreguntaOrigen) {
            idPreguntaOrigen = copia.id_pregunta
          }
        }
      }

      const base = {
        ...datosBase,
        id_instrumento: instrumento.id_instrumento,
        id_pregunta_origen: idPreguntaOrigen,
      }

      if (p.general) {
        const resultado = await preguntaStore.crearPregunta({ ...base, id_grupo_interes: null, orden: orden++ })
        if (!resultado) {
          mostrarMensaje('Error al crear la pregunta general.')
          return
        }
      } else {
        for (const idGrupo of p.gruposDestino) {
          const resultado = await preguntaStore.crearPregunta({ ...base, id_grupo_interes: idGrupo, orden: orden++ })
          if (!resultado) {
            mostrarMensaje(`Error al crear pregunta para "${nombreGrupo(idGrupo)}".`)
            return
          }
        }
      }
    }

    emit('creado', `Formulario creado con ${preguntas.value.length} pregunta(s).`)
    emit('cerrar')
  } catch (e: any) {
    mostrarMensaje(e?.message ?? 'Error al crear el formulario.')
  } finally {
    guardando.value = false
  }
}
</script>

<style scoped>
.overlay-modal {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1.5rem;
}

.modal-crear {
  background: #fff;
  border-radius: 10px;
  padding: 1.4rem;
  width: 100%;
  max-width: 620px;
  max-height: 88vh;
  overflow-y: auto;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.22);
  font-family: var(--font-family, inherit);
}

.modal-titulo {
  margin: 0 0 0.5rem;
  font-size: 1.1rem;
  font-weight: 700;
}

.nota {
  margin: 0 0 1.1rem;
  padding: 0.6rem 0.75rem;
  border-left: 3px solid #eea222;
  background: #fdf6e7;
  border-radius: 4px;
  font-size: 0.8rem;
  line-height: 1.45;
  color: #5c4a1e;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  margin-bottom: 0.8rem;
}

.form-group label {
  font-size: 0.8rem;
  font-weight: 600;
  color: #444;
}

input, select, textarea {
  padding: 0.5rem 0.65rem;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-family: inherit;
  font-size: 0.85rem;
}

.seccion-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 1rem 0 0.6rem;
}

.banco {
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  padding: 0.2rem 0.8rem 0.8rem;
  background: #fafcff;
}

.contador {
  background: #0e69a0;
  color: #fff;
  border-radius: 10px;
  padding: 0.1rem 0.5rem;
  font-size: 0.72rem;
}

.lista-banco {
  list-style: none;
  margin: 0 0 0.6rem;
  padding: 0;
  max-height: 170px;
  overflow-y: auto;
}

.item-banco label {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 0.25rem 0;
  font-size: 0.8rem;
  cursor: pointer;
}

.bq-texto {
  flex: 1;
}

.seccion-head h5 {
  margin: 0;
  font-size: 0.9rem;
  font-weight: 700;
}

.pregunta-card {
  border: 1px solid #ececec;
  border-radius: 8px;
  padding: 0.7rem 0.8rem;
  margin-bottom: 0.6rem;
  background: #fdfdfd;
}

.pregunta-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
  font-size: 0.82rem;
}

.btn-quitar {
  border: none;
  background: none;
  color: #b00020;
  cursor: pointer;
  font-size: 0.9rem;
}

.info {
  font-size: 0.82rem;
  color: #888;
}

.botones {
  display: flex;
  justify-content: flex-end;
  gap: 0.7rem;
  margin-top: 1.1rem;
}

.btn {
  padding: 8px 20px;
  height: 38px;
  font-weight: 600;
  font-size: 0.83rem;
  font-family: inherit;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.btn-sm {
  height: auto;
  padding: 0.35rem 0.8rem;
  font-size: 0.78rem;
}

.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn.salir {
  background: #fff;
  border: 1px solid #ccc;
}

.btn.guardar {
  background: #eea222;
  color: #000;
}

.btn.guardar:not(:disabled):hover {
  background: #0e69a0;
  color: #fff;
}

.borrador-card {
  border: 2px dashed #0e69a0;
  border-radius: 8px;
  padding: 0.7rem 0.8rem;
  margin-bottom: 0.8rem;
  background: #f5faff;
}

.borrador-botones {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 0.6rem;
}

.grupos-lista {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 1.2rem;
  margin-top: 0.25rem;
}

.grupo-check {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.85rem;
  cursor: pointer;
}

.banco-filtro {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.banco-select-todo {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.78rem;
  font-weight: 600;
  color: #0e69a0;
  cursor: pointer;
  margin-bottom: 0.35rem;
  padding: 0.15rem 0;
}

.banco-grupo-select {
  padding: 0.25rem 0.5rem;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 0.78rem;
  font-family: inherit;
}

.radio-dest {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  margin-top: 0.2rem;
}

.radio-label {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.82rem;
  cursor: pointer;
}

.grupos-check-mini {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem 1rem;
  margin-top: 0.4rem;
  padding-left: 0.5rem;
}

.grupo-check-mini {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  font-size: 0.8rem;
  cursor: pointer;
}

.resumen-grupos {
  margin-top: 0.75rem;
  padding: 0.6rem 0.8rem;
  background: #f0f7ff;
  border: 1px solid #c6ddf7;
  border-radius: 6px;
}

.resumen-titulo {
  margin: 0 0 0.4rem;
  font-size: 0.78rem;
  font-weight: 700;
  color: #0e69a0;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.resumen-lista {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.resumen-item {
  font-size: 0.82rem;
  color: #333;
}

.resumen-item--vacio {
  color: #721c24;
  font-weight: 600;
}

.resumen-alerta {
  font-size: 0.76rem;
  color: #721c24;
  font-style: italic;
  margin-left: 0.4rem;
}
</style>
